import * as React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Button, Menu } from '@mui/material';
const PopOverCTA = ({ btnText, varientText, children, btnDisabled, onToggle=()=>{},onCloseItem=false, menuMaxHeight }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (closeMenu) => {
        if(closeMenu){ 
            setAnchorEl(null);
            setTimeout(() => {
            onToggle();
            }, [200])
    }
    };

    return (
        <>
            <Button size='small' variant= {varientText ? varientText : 'outlined'} color='primary' onClick={handleClick} disabled={btnDisabled} endIcon={<ArrowDropDownIcon fontSize='small' />}>
                {btnText}
            </Button>
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={()=>handleClose(true)}   
                onClick={()=>handleClose(onCloseItem)}
                slotProps={menuMaxHeight ? { paper: { sx: { maxHeight: menuMaxHeight, overflow: 'auto' } } } : undefined}
            >
                {children}
            </Menu>
        </>
    )
}
export default PopOverCTA;
